// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'pause';

export const Component = () => (
  <path d='M6.485 5h2.97c.335 0 .718.096 1.054.335.239.192.382.431.382.767v12.547c0 .335-.143.575-.382.767-.336.239-.72.335-1.054.335h-2.97c-.335 0-.719-.096-1.054-.335-.287-.192-.431-.432-.431-.767V6.102c0-.336.144-.575.431-.767A1.829 1.829 0 0 1 6.485 5Zm3.449 13.41V6.341c0-.239-.144-.382-.48-.382H6.486c-.335 0-.479.143-.479.382v12.07c0 .238.144.334.48.334h2.969c.335 0 .479-.096.479-.335ZM15.298 5h2.97c.334 0 .718.096 1.053.335.288.192.431.431.431.767v12.547c0 .335-.143.575-.43.767-.336.239-.72.335-1.055.335h-2.97c-.335 0-.718-.096-1.053-.335-.24-.192-.383-.432-.383-.767V6.102c0-.336.144-.575.383-.767A1.829 1.829 0 0 1 15.298 5Zm3.448 13.41V6.341c0-.239-.144-.382-.479-.382h-2.97c-.335 0-.478.143-.478.382v12.07c0 .238.143.334.479.334h2.97c.334 0 .478-.096.478-.335Z' />
);

export const viewBox = '0 0 25 25';
